import { combineReducers } from '@reduxjs/toolkit';
import { communityActivityLogsSlice } from './communityActivityLogs.slice';

export const activityLogsReducer = combineReducers({
  communityActivityLogs: communityActivityLogsSlice.reducer
  //   companyActivityLogs:
});
